import {
  RouterProvider as TanStackRouterProvider,
  type AnyRouter,
} from "@tanstack/react-router";
import { useClient } from "urql";
import { useAuth } from "./auth-provider";

type RouterProviderProps = {
  router: AnyRouter;
};

export function RouterProvider({ router }: RouterProviderProps) {
  const auth = useAuth();
  const urqlClient = useClient();

  return (
    <TanStackRouterProvider router={router} context={{ urqlClient, auth }} />
  );
}
